<div class="page-layout blank flex flex-col">
  <particle-message-bar [notificationId]="notificationId"></particle-message-bar>

  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <label class="component-label"> Actions</label>
      <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">

        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button
                  matTooltip="Automatically create the cross-border
                  transactions for all payment streams between the
                  countries selected in the Entity Chart settings.
                  You can limit the stream types in the Streams settings."
                  class="orbitax-flat-button"
                  (click)=createTransactionsBetweenMyCountries()
                  [disabled]="entityCount<=0">
            Create Transactions Between My Countries
          </button>
          <div class="toolbar-separator"></div>

        </div>
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button
                  class="orbitax-flat-button mat-button"
                  (click)=deleteAllTransaction()
                  [disabled]="totalTransaction<=0">
            Delete All Transactions
          </button>
          <div class="toolbar-separator"></div>

        </div>
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button
                  class="orbitax-flat-button mat-button"
                  (click)="navigateToTransactionsImport()">
            Import Transactions
          </button>
          <div class="toolbar-separator"></div>
        </div>

        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button"
                  particleAnalytics
                  analyticsCategory="task-manager-board"
                  analyticsAction="add task"
                  (click)="resetTransactionFromProjectSettings()">Reset Transactions from Project Settings
          </button>
          <div class="toolbar-separator"></div>
        </div>

      </div>
    </div>
  </div>

  <mat-tab-group [selectedIndex]="selectedIndex" (selectedTabChange)="tabChanged($event)"
                 class=" full-grow-no-shrink-no-basistabs-container"
                 style="height: 0">
    <mat-tab
      *ngIf="(hasFeature$ | async)(transactionFeatures.CRTransactionAdd) || (hasFeature$ | async)(transactionFeatures.CRTransactionTopicEdit)"
      label="Manage Transactions">
      <div class="flex flex-row min-height p-t-10 p-b-10 flex-1-0-75">
        <lib-app-transaction-settings class="flex-1-0-auto"
                                      [sourceA]="sourceA$"
                                      [sourceB]="sourceB$"
                                      [selectedSources]="selectedSources$"
                                      [streamData]="streamSelectorData$"
                                      [resetSelection]="resetSelection$"
                                      (countryClicked)="onCountryClick($event)"
                                      (streamSelected)="onStreamClick($event)"
                                      [streamQuickSelectionsOptions]="streamQuickSelections$"
        ></lib-app-transaction-settings>
      </div>
    </mat-tab>

    <mat-tab *ngIf="(hasFeature$ | async)(transactionFeatures.CRTransactionTopic)" label="Transactions Overview">
      <lib-app-transaction-overview (rowSelected)="setSelectedSources($event)"></lib-app-transaction-overview>
    </mat-tab>
  </mat-tab-group>
</div>


